import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { zodFlavorId } from "../ids.mjs";
import { z as z$1 } from "zod";

// src/models/projections/canvasPatientProjection.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/** Fixed doc id under `customers/{customerId}/projections/canvasPatient`. */
const CANVAS_PATIENT_PROJECTION_KEY = "canvasPatient";
/**
* Lean client gate for Canvas patient readiness.
* Path: `customers/{customerId}/projections/canvasPatient`.
*/
const canvasPatientProjectionSchema = z$1.object({
	id: zodFlavorId(),
	/** True when L4 `canvas_patients/{customerId}` has `vendorNativeId`. */
	patientExists: z$1.boolean(),
	inSync: z$1.boolean().default(false),
	createdAt: firestoreDate,
	updatedAt: firestoreDate
});
/** Pub/Sub ordering key for canvasPatient projection resolve. */
function buildCanvasPatientProjectionOrderingKey(customerId) {
	return `customers/${customerId}/projections/${CANVAS_PATIENT_PROJECTION_KEY}`;
}

export { CANVAS_PATIENT_PROJECTION_KEY, buildCanvasPatientProjectionOrderingKey, canvasPatientProjectionSchema };
//# sourceMappingURL=canvasPatientProjection.mjs.map